import $ from 'jquery';

const toggleFieldBasedOnCheckbox = (checkbox, field) => {
  if (checkbox.is(':checked')) {
    field.removeClass('disabled');
  } else if (checkbox.is(':not(:checked)')) {
    field.addClass('disabled');
  }
};

const toggleFields = checkbox => {
  const field = checkbox.parent().parent().parent().find('.field').last();
  toggleFieldBasedOnCheckbox(checkbox, field);
};

const toggleWorkTimes = checkbox => {
  const field = checkbox.parent().parent().parent().find('.fields > div');
  toggleFieldBasedOnCheckbox(checkbox, field);
};

const toggleBulkCheckbox = $bulkActionButton => {
  setTimeout(() => {
    $bulkActionButton.prop(
      'disabled',
      !$bulkActionButton.data('button-always-active') ? $('input.bulk-select-checkbox:checked').length < 1 : false,
    );
  });
};

const addAllIdsInputs = $form => {
  $('input.bulk-select-checkbox').each((index, element) => {
    $(`<input type="hidden" name="allIds[]" value="${element.value}">`).appendTo($form);
  });
};

const AdminBulkAction = (() => {
  let $form;
  const $bulkActionButton = $('.js__admin_bulk_action');

  const init = () => {
    $bulkActionButton.click(e => {
      e.preventDefault();
      const $button = $(e.currentTarget);
      $form = $button.closest('form');
      if ($('input.bulk-select-checkbox:checked').length > 0) {
        $('input.bulk-select-checkbox:checked').each((index, element) => {
          const isItemWithRelatedEntity = $(element)
            .closest('.item')
            .find('.js__entity-related')
            .data('entity-related');
          if (!$form.find(`input[value="${element.value}"]`).length) {
            $(`<input type="hidden" name="ids[]" value="${element.value}">`).appendTo($form);
          }

          if (isItemWithRelatedEntity) {
            $('.js__related-entity-text').removeClass('hidden');
          }
        });

        addAllIdsInputs($form);

        if (!$button.is('[data-bulk-action-requires-confirmation]')) {
          $form.submit();
        }
      } else {
        addAllIdsInputs($form);

        if (!$button.is('[data-bulk-action-requires-confirmation]')) {
          $form.submit();
        }
      }
    });

    toggleBulkCheckbox($bulkActionButton);

    $('[data-js-bulk-buttons=".sylius-grid-nav__bulk"]').on('change', e => {
      toggleBulkCheckbox($bulkActionButton);
    });

    $('.bulk-select-checkbox').on('change', e => {
      if ($form) {
        const $input = $form.find(`input[value="${e.currentTarget.value}"]`);
        $('.js__related-entity-text').addClass('hidden');
        $input.remove();
      }
      toggleBulkCheckbox($bulkActionButton);
    });

    const $dropdown = $('.js__bulk_multiple_select');
    $dropdown.dropdown({
      onAdd: function (value) {
        const $this = $(this);
        const partialValue = `${value}_partial`;
        setTimeout(() => {
          if ($this.dropdown('get values').indexOf(partialValue) !== -1) {
            $this.dropdown('remove selected', partialValue);
            $this.dropdown('remove selected', value);
            $this.dropdown('set selected', value);
          }
        });
      },
      onRemove: function (value, text, $choice) {
        if (value.indexOf('_partial') !== -1) {
          const $originalChoice = $(this)
            .find('.menu')
            .find(`[data-value="${value.replace('_partial', '')}"]`);
          $originalChoice.find('.description').hide();
          $choice.replaceWith($originalChoice);
        }
      },
      onChange: function () {
        const $menu = $(this).find('.menu');

        if ($menu.find('[data-value*="_partial"]').length === 0) {
          $menu.find('.header, .divider').remove();
        }
      },
      onLabelCreate: function (value) {
        if (value.indexOf('_partial') !== -1) {
          this.addClass('disabled');
        }

        return this;
      },
    });

    const checkboxes = $('.js__bulk_edit_field_toggle');
    checkboxes.on('change', event => {
      toggleFields($(event.target));
    });

    $.each(checkboxes, (index, checkbox) => {
      toggleFields($(checkbox));
    });

    const workTimesCheckboxes = $('.js__bulk_edit_work_time_toggle');
    workTimesCheckboxes.on('change', event => {
      toggleWorkTimes($(event.target));
    });

    $.each(workTimesCheckboxes, (index, checkbox) => {
      toggleWorkTimes($(checkbox));
    });

    const toggleTranslationFields = checkbox => {
      const field = checkbox.parent().parent().find('.field');
      toggleFieldBasedOnCheckbox(checkbox, field);
    };

    const translationsCheckboxes = $('.js__bulk_edit_translations_toggle');
    translationsCheckboxes.on('change', event => {
      toggleTranslationFields($(event.target));
    });

    $.each(translationsCheckboxes, (index, checkbox) => {
      toggleTranslationFields($(checkbox));
    });
  };

  return {
    init,
  };
})();

export default AdminBulkAction;
